<template>
    <!--<div class="position-relative">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <i class="fa fa-user mr-1 d-sm-none" aria-hidden="true"></i>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="dropdown-menu small m-0 p-0 mw-100">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item small"><i class="fa fa-user"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
            <a class="nav-link" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();">
                <i class="fa fa-user mr-1" aria-hidden="true"></i>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
            </a>
            <span class="pipe" v-if="showRegistration"></span>
            <a class="nav-link" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'"  @click="createRegisterModal(); unmarkInputFields();" v-if="showRegistration">
                <i class="fa fa-user-plus mr-1" aria-hidden="true"></i>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
            </a>
        </div>
    </div>-->

    <div id="login-change" v-if="isMobile">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle"  data-testing="register-select" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window" :aria-label="$translate('Ceres::Template.loginRegister')">
                <i class="fa fa-user d-sm-none" aria-hidden="true"></i>
                <span class="hidden-xs-down">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small">
                <div class="list-group" aria-labelledby="accountMenuList">
                    <a :href="$ceres.urls.myAccount"><i class="fa fa-user"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn" class="dropdown">
            <a href="#" class=""  data-testing="login-select" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window" :aria-label="$translate('Ceres::Template.login')">
                <i aria-hidden="true" class="fa fa-user"></i>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal();unmarkInputFields()">
                    <i class="fa fa-user" aria-hidden="true"></i>
                    <span class="hidden-xs-down">{{ $translate("Ceres::Template.login") }}</span>
                    </a>
                    <a :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'" @click="createRegisterModal();unmarkInputFields()" v-if="showRegistration">
                    <i class="fa fa-user-plus" aria-hidden="true"></i>
                    <span class="hidden-xs-down">{{ $translate("Ceres::Template.loginRegister") }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>

	<div id="login-change" v-else>
		<template v-if="isLoggedIn">
			<a href="#" class="login-btn" v-logout>{{ $translate("Ceres::Template.loginLogout") }}</a>
			<a class="register-btn" :href="$ceres.urls.myAccount">{{ $translate("Ceres::Template.loginMyAccount") }}</a>
		</template>
		<template v-if="!isLoggedIn">
			<a class="login-btn" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal();unmarkInputFields()">
				{{ $translate("Ceres::Template.login") }}
			</a>
			<a class="register-btn" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'" @click="createRegisterModal();unmarkInputFields()" v-if="showRegistration">
				{{ $translate("Ceres::Template.loginRegister") }}
			</a>
		</template>
	</div>
</template>

<script>
import ValidationService from "ceres/app/services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register",
			isMobile: false
        };
    },

	mounted(){
		this.isMobile = window.innerWidth < 992
	},

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
